import * as Dropzone from 'react-dropzone'

export type OnRemove = (file: Dropzone.FileWithPath, listIndex: number) => void

export interface FilePickerOptions {
  isDisabled?: boolean
  fileList?: Dropzone.FileWithPath[]
  maxSize?: number
  accept?: string[]
  multiple?: boolean
  folderDrop?: boolean
  onDropAccepted: (files: Dropzone.FileWithPath[]) => void
  onDropRejected?: (fileRejections: FileRejection[]) => void
  validator?: (file: File) => Dropzone.FileError | Dropzone.FileError[]
  noClick?: boolean
}

export interface FileListOptions {
  show?: boolean // Defaults to true
  onRemove?: OnRemove
  onRemoveError?: OnRemove // Called when an error state upload is removed
  showFileCount?: boolean
  variant?: 'default' | 'ai'
  maxHeight?: string
}

export interface Props {
  filePickerOptions: FilePickerOptions
  fileListOptions?: FileListOptions
}

export enum FileRejectionCode {
  FILE_TOO_LARGE = 'file-too-large',
  FILE_NAME_INVALID = 'file-name-invalid'
}

export interface FileRejection {
  code: FileRejectionCode
  file: File
  message: string
}
